import styles from './FormButtonV2.module.scss'
import React from 'react'

const Loader = ({ primary }) => {
  return (
    <div className={styles.container}>
      <div className={!primary ? styles.dot : styles.dotPrimary} />
    </div>
  )
}

export default Loader
